module.exports = __webpack_public_path__ + "static/media/whenthelaughsstop.2abc426e.png";